export const GET_ALL_DEVICES = "GET_ALL_DEVICES"
export const SEARCH_DEVICE = "SEARCH_DEVICE"
export const GET_DEVICE = "GET_DEVICE"
